module.exports = __webpack_public_path__ + "assets/kids/img/logo-cybermobbing.db3f0c2b.png";